import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/miniiwiki.mn-frontend/components/content-category/content-category.jsx");
